import { RefObject, useLayoutEffect } from "react";
import { gsap, ScrollTrigger } from "./gsap";

const useParallax = (scopeRef: RefObject<HTMLElement>) => {
    useLayoutEffect(() => {
        const scope = scopeRef.current;
        if (!scope) return;

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        const context = gsap.context(() => {
            ScrollTrigger.matchMedia({
                "(min-width: 768px)": () => {
                    const elements = gsap.utils.toArray<HTMLElement>("[data-parallax]", scope);

                    elements.forEach((element) => {
                        const speed = Number(element.dataset.parallax || 0.12);

                        gsap.to(element, {
                            yPercent: speed * 100,
                            ease: "none",
                            scrollTrigger: {
                                trigger: element,
                                scrub: true,
                                start: "top bottom",
                                end: "bottom top",
                            },
                        });
                    });
                },
            });
        }, scope);

        return () => context.revert();
    }, [scopeRef]);
};

export default useParallax;
